import { ErrorBannerStyles } from "./ErrorBanner.styles.ts";
import { FC, ReactNode, Ref } from "react";
import ErrorOutline from "@mui/icons-material/ErrorOutline";

export interface ErrorBannerProps {
	errorMessaging: ReactNode;
	isLoading?: boolean;
	ref?: Ref<HTMLDivElement>;
}
const ErrorBanner: FC<ErrorBannerProps> = ({ isLoading, errorMessaging, ref }: ErrorBannerProps) => {
	return (
		<ErrorBannerStyles
			ref={ref}
			isLoading={isLoading}
			data-testid="api-error-banner-header"
		>
			<ErrorOutline />
			{errorMessaging}
		</ErrorBannerStyles>
	);
};

ErrorBanner.displayName = "ErrorBanner";
export default ErrorBanner;
